export const BASE_URL = 'https://api.alradwan-medical.com';